export interface RecentPurchase {
  nombre: string;
  ciudad: string;
}

export const recentPurchases: RecentPurchase[] = [
  { nombre: 'Laura', ciudad: 'Madrid' },
  { nombre: 'Cristina', ciudad: 'Barcelona' },
  { nombre: 'Beatriz', ciudad: 'Alicante' },
  { nombre: 'Nuria', ciudad: 'Murcia' },
  { nombre: 'Silvia', ciudad: 'Palma de Mallorca' },
  { nombre: 'Raquel', ciudad: 'Vigo' },
  { nombre: 'Paula', ciudad: 'Gijón' },
  { nombre: 'Elena', ciudad: 'Bilbao' },
  { nombre: 'Marta', ciudad: 'Zaragoza' },
  { nombre: 'Carmen', ciudad: 'Valencia' }
];
